import './bootLocale.ts'

import { mountApp } from '@ctcells/ui'
import '@ctcells/ui/styles.css'

import { routes } from './routes.tsx'

/*
 * 🔴 `skin: 'console'`(eric 확정 2026-09-22 · 「방안 A」). `<html data-skin="console">` 아래에서만 새 토큰 값이 선다.
 *    이 앱과 모듈 앱 3개(원심 · 어셈 · 염색 — 2026-10-16~18 콘솔 판을 그대로 쓰는 모니터링 앱)가 단다.
 *    `console-equipment` 만 속성이 없어 종전 흑백 토큰으로 선다.
 */
mountApp(routes, { skin: 'console' })
